import { render } from "./AiArticles.vue?vue&type=template&id=0298a901&scoped=true"
import script from "./AiArticles.vue?vue&type=script&lang=js"
export * from "./AiArticles.vue?vue&type=script&lang=js"

import "./AiArticles.vue?vue&type=style&index=0&id=0298a901&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0298a901"]])

export default __exports__